const ACL = {
  aprovar_arrematante: [
    'camila.rocha', 59095,
    'rmenezes', 10238,
    'tiagofelipe', 488,
    'elaine.carvalho', 56559,
    'yasmin.gomes', 57082,
    'raiana.guimaraes', 72966,
    'matheusnunes', 80909,
    'andrebastos', 11602,
    'marcosmelo', 80905,
    'alexandrerm', 55849,
    'kelly.siqueira', 67622,
    'livia.braga', 93827,
    'WMR', 80899,
    'suporte', 40544,
    'gilber.mirandola', 48517,
    'gabriel.chaffin', 88911,
    'LUCAS.FONSECA', 100517,
    'igor.nunes', 105598,
    'MARTINHA3', 98716,
    'luka.jacob', 119252,
    'beatriz.moura', 119277,
    'lucineide.goncalves', 124541,
    'erik.castro', 128237,
    'viniciusaffonso', 80914,
    'edgard.nunes', 80913,
    'franklin.ferreira', 151743,
    'andre.luis', 173232,
    'ana.paula.chagas', 180372,
    'marcus.vinicius.andrade', 180373,
    'ingrid.silva.conceicao', 180374,
    'marcelo.silva.ferreira', 180375,
    'lucas.silva', 166161,
    'lidiane.melo', 184287,
    'amanda.pereira', 188682,
    'jose.alexandre', 185661,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585,
    'luana.marinho', 199951,
    'eliana.silva', 200737,
    'taine.santos', 200736,
    'karina.silva', 194584
  ],
  deletar_lance: [
    'WMR', 80899,
    'rmenezes', 10238,
    'tiagofelipe', 488,
    'andrebastos', 11602,
    'edgard.nunes', 80913,
    'viniciusaffonso', 80914,
    'andre.luis', 173232,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ],
  controlar_leilao: [
    'suporte', 40544,
    'WMR', 80899,
    'rmenezes', 10238,
    'tiagofelipe', 488,
    'andrebastos', 11602,
    'edgard.nunes', 80913,
    'viniciusaffonso', 80914,
    'andre.luis', 173232,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ],
  deletar_lote_leilao: [
    'WMR', 80899,
    'rmenezes', 10238,
    'tiagofelipe', 488,
    'andrebastos', 11602,
    'alexandrerm', 55849,
    'edgard.nunes', 80913,
    'viniciusaffonso', 80914,
    'andre.luis', 173232,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ],
  alterar_status_leilao: [
    'suporte', 40544,
    'WMR', 80899,
    'rmenezes', 10238,
    'andrebastos', 11602,
    'tiagofelipe', 488,
    'alexandrerm', 55849,
    'edgard.nunes', 80913,
    'viniciusaffonso', 80914,
    'andre.luis', 173232,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ],
  alterar_status_lote: [
    'suporte', 40544,
    'WMR', 80899,
    'rmenezes', 10238,
    'andrebastos', 11602,
    'tiagofelipe', 488,
    'edgard.nunes', 80913,
    'viniciusaffonso', 80914,
    'andre.luis', 173232,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ],
  gerenciar_usuario_intranet: [
    'suporte', 40544,
    'WMR', 80899,
    'rmenezes', 10238,
    'tiagofelipe', 488,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ],
  rh: [
    'suporte', 40544,
    'WMR', 80899,
    'rmenezes', 10238,
    'tiagofelipe', 488,
    'elaine.carvalho', 56559,
    'kelly.siqueira', 67622,
    'camila.rocha', 59095,
    'andre.luis', 173232,
    'amanda.pereira', 188682,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ],
  excluir_arrematante: [
    'suporte', 40544,
    'WMR', 80899,
    'rmenezes', 10238,
    'tiagofelipe', 488,
    'andrebastos', 11602,
    'edgard.nunes', 80913,
    'viniciusaffonso', 80914,
    'andre.luis', 173232,
    'suzana.oliveira', 197697,
    'nivia.souza', 156041,
    'amanda.pereira', 188682,
    'emilly.fernandes', 195418,
    'helena.ferreira', 194587,
    'haillainy.sales', 194586,
    'ceane.ferreira', 194585
  ]
}

export const CHECK_ACL = function (acl, user) {
  if (typeof ACL[acl] !== 'undefined') {
    /* if(typeof user === 'undefined'){
      user =
    } */
    return ACL[acl].includes(user)
  }
}

export default {
  check: CHECK_ACL,
  acl: ACL
}



// WEBPACK FOOTER //
// ./src/domain/acl/tmp-acl.js